import { render } from "./DashboardLayout.vue?vue&type=template&id=d2792586&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts"

import "./DashboardLayout.vue?vue&type=style&index=0&id=d2792586&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d2792586"

export default script